import React, { Component } from 'react'

class LeaguesErrorPopup extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state={

        }
    }

    onSubmit(){
        if(this.props.onSubmit){
            this.props.onSubmit()
        }
    }

    render() {
        return (
            <div className="si-modal-wrap">
                <div className="si-common-popup si-invite-popup">
                    <div className="si-popup-body si-flexBox">
                        <i className="si-close icon-ucl-close" onClick={this.onSubmit}></i>
                        <div className="si-logo-wrap">
                            <span><i className="icon-ucl-join"></i></span>
                        </div>
                        <div className="si-details-wrap">
                            <div className="si-more-info">
                                <span dangerouslySetInnerHTML={{__html : this.props.message}}></span>
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <div className="si-btn si-btn-primary" onClick={this.onSubmit}>
                            <span>{this.props.buttonText}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LeaguesErrorPopup;


// WEBPACK FOOTER //
// ./src/components/leagues/LeaguesErrorPopup.js